import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { getData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import { WMS1101_R01DetailDto, WMS1101_R01HeaderDto } from "./Dto_WMS1101_R01";
import { WMS1101_R01Filter } from "./Store_WMS1101_R01";


const baseUrl = `${config.apiUrl}/WMS1101_R01`;

const getParams = (filter: Partial<WMS1101_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getWMS1101_R01List = async (option: string, params: Partial<WMS1101_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS1101_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS1101_R01AllCount = async (params: Partial<WMS1101_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS1101_R01DetailList = async (transportCode: string) => {
	const url = `${baseUrl}/detail/${transportCode}`;

	return await getData<ResponseDto<WMS1101_R01DetailDto[]>>(url);
}

export const downloadExcel_WMS1101_R01 = async (option: string, transportNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			transportNo
		}
	})
}
